import { render, staticRenderFns } from "./WinTable.vue?vue&type=template&id=4fcfc910&scoped=true&slot-scope=scope&"
import script from "./WinTable.vue?vue&type=script&lang=js&"
export * from "./WinTable.vue?vue&type=script&lang=js&"
import style0 from "./WinTable.vue?vue&type=style&index=0&id=4fcfc910&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fcfc910",
  null
  
)

export default component.exports